export const UPLOAD_FILE_REQUEST = "UPLOAD_FILE_REQUEST";
export const UPLOAD_FILE_SUCCESS = "UPLOAD_FILE_SUCCESS";
export const UPLOAD_FILE_FAILURE = "UPLOAD_FILE_FAILURE";
export const RESET_UPLOAD_FILE_STATE = "RESET_UPLOAD_FILE_STATE";
export const CUSTOMER = "customer";
export const VENDOR = "vendor";

export const SET_SELECTED_FILE = "SET_SELECTED_FILE";
